const TrafficPlanTemplate = () =>
  import(
    /* webpackChunkName: "time-sheet-traffic-plan-template" */ '@/pages/time-sheet/traffic-plan-template/index.vue'
  )
const CreateTrafficPlanTemplate = () =>
  import(
    /* webpackChunkName: "time-sheet-traffic-plan-template" */ '@/pages/time-sheet/traffic-plan-template/create.vue'
  )
const EditTrafficPlanTemplate = () =>
  import(
    /* webpackChunkName: "time-sheet-traffic-plan-template" */ '@/pages/time-sheet/traffic-plan-template/edit.vue'
  )

export default {
  path: 'traffic-plan-template',
  meta: {
    label: 'trafficPlanTemplate',
    auth: 'trafficPlanTemplate'
  },
  component: {
    name: 'TrafficPlanTemplate',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'TimeSheetTrafficPlanTemplate',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: TrafficPlanTemplate
    },
    {
      name: 'TimeSheetCreateTrafficPlanTemplate',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateTrafficPlanTemplate
    },
    {
      name: 'TimeSheetEditTrafficPlanTemplate',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditTrafficPlanTemplate,
      props: true
    }
  ]
}
